const EXPIRES = {
	MAX: "Fri, 31 Dec 9999 23:59:59 GMT",
};

/* vraci hodnotu susenky dle hledaneho nazvu */
export function getCookieValue(sKey: string): string {
	if (!sKey) {
		return "";
	}

	/* eslint-disable */
	return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || "";
}

/**
 * Set cookie. Default expiration is 30 days from creation.
 *
 * @param  {String} name
 * @param  {String} value
 * @param  {Object} [optsArg]
 * @param  {Number|String|Date} [optsArg.expiration=null] Cookie expiration
 * @param  {String} [optsArg.path=""] Cookie path
 * @param  {String} [optsArg.domain=""] Cookie domain
 * @param  {String} [optsArg.secure=""] Cookie secure
 * @return {Boolean}
 */
export function setCookieValue(name: string, value: string, optsArg?: { expiration?: string | Date | number | null; path?: string; domaing?: string; secure?: boolean; }): boolean {
	if (!name || /^(?:expires|max-age|path|domain|secure)$/iu.test(name)) { return false; }

	const curDate = new Date();
	curDate.setMonth(curDate.getMonth() + 1);

	const opts = {
		expiration: curDate,
		path: "",
		domain: "",
		secure: false,
		...optsArg,
	};
	let expires = "";

	if (opts.expiration) {
		switch (opts.expiration.constructor) {
			case Number:
				expires = opts.expiration === Infinity ? "; expires=" + EXPIRES.MAX : "; max-age=" + opts.expiration;
				break;

			case String:
				expires = "; expires=" + opts.expiration;
				break;

			case Date:
				expires = "; expires=" + opts.expiration.toUTCString();
				break;
		}
	}

	document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + (opts.domain ? "; domain=" + opts.domain : "") + (opts.path ? "; path=" + opts.path : "") + (opts.secure ? "; secure" : "");
	return true;
}

export function getItemInd(array: Array<any>, compareFunc: Function): number {
	let ind = -1;

	for (let ind = 0, max = array.length; ind < max; ind++) {
		if (compareFunc(array[ind])) {
			return ind;
		}
	}

	return ind;
}

export function loadScript(src: string, loadCb?: Function) {
	const script = document.createElement("script");
	script.src = src;
	script.type = "text/javascript";
	script.async = true;
	script.addEventListener("load", () => {
		loadCb && loadCb();
	});

	document.head.append(script);
}

export function addMeta(name: string, content: string) {
	const queryElem = document.querySelector(`meta[name='${name}']`);

	if (queryElem) {
		(queryElem as HTMLMetaElement).content = content;
	} else {
		const description = document.createElement("meta");

		description.name = name;
		description.content = content;
		document.head.appendChild(description);
	}
}

export function getClassName(classes: Array<string>): string {
	const filtered = classes.filter(item => item.length > 0);

	return filtered.join(" ");
}
